exports.LANDING_HERO =
  'https://images.angelstudios.com/image/upload/v1699022164/angel-funding/hero'
exports.LANDING_HERO_DESKTOP =
  'https://images.angelstudios.com/image/upload/v1699022165/angel-funding/hero_desktop'
exports.LANDING_HERO_MOBILE =
  'https://images.angelstudios.com/image/upload/w_412,h_790,c_thumb,g_auto/v1699022164/angel-funding/hero'
